import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { LeeftijdIcon } from "../../atoms/icons/LeeftijdIcon";

// All the incoming values
interface IProps {
    birthDate?: Date | null;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & Omit<IDefaultViewProps<string | null>, 'value'>;
export const Leeftijd = (props: AllProps) => {
    const calculateAge = (birthDate: Date | null): number | null => {
        if (!birthDate) return null;
        return Math.floor((new Date().getTime() - new Date(birthDate).getTime()) / (1000 * 60 * 60 * 24 * 365.25));
    };

    const age = calculateAge(props.birthDate || null);

    return (<Caption {...props} caption={props.label || "Leeftijd"} icon={<LeeftijdIcon />}>
        {age !== null ? age.toString() : '-'}
    </Caption>)
}

